/**
 * Browser-safe GeoJSON → engine-geometry helper (M9).
 *
 * Extracted from the pg provider so the per-source adapters + any client code can
 * reuse it WITHOUT importing the pg pool (`@/lib/db/pool`) that the deploy-time
 * provider needs. Pure: Polygon / MultiPolygon → the engine's flat outer-ring
 * list (`Ring[]`), the geometry shape M9-A froze.
 */

import type { Ring } from "@/lib/analysis/geometry";

/** Parse a GeoJSON Polygon / MultiPolygon geometry into flat outer rings. */
export function geojsonToRings(geojson: unknown): Ring[] {
  const g = geojson as { type?: string; coordinates?: unknown };
  if (g.type === "Polygon") {
    const coords = g.coordinates as number[][][];
    return coords.length > 0 ? [coords[0] as Ring] : [];
  }
  if (g.type === "MultiPolygon") {
    const coords = g.coordinates as number[][][][];
    return coords.map((poly) => poly[0] as Ring).filter((r) => Array.isArray(r));
  }
  return [];
}
